module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.4b33f3d.eot";